	angular.module('qkr').controller('MachinesController', MachinesController);

	MachinesController.$inject = [
		'$uibModal',
		'$routeSegment',
		'$routeParams',
		'outletSummaryList',
		'machines',
		'getDiscountLabelFn',
		'deleteMachineFn',
		'appConfig',
		'messageService',
		'gettextCatalog',
		'APP_CONSTANT'];

	function MachinesController($uibModal, $routeSegment, routeParams, outletSummaryList, machines, getDiscountLabelFn,
                                deleteMachineFn, appConfig, messageService, gettextCatalog) {
		const vm = this;
		vm.outlets = [];
		vm.loaded = false;
		vm.isElevatedUser = appConfig.isElevatedUser;
		vm.adminLevel = appConfig.adminLevel;
		vm.getDiscountLabel = getDiscountLabelFn;
		vm.machinesList = [];
		vm.isAtMerchant = !!routeParams.AtMerchant || false;

        const outlets = machines.reduce((acc, machine) => {
            let outlet = acc.find (o => o.id === machine.outletId);
            if (outlet === undefined) {
                outlet = {id: machine.outletId, name: '', machines: []};
                acc.push(outlet);
            }
            outlet.machines.push(machine);
            return acc;
        }, []);

        outlets.forEach(outlet => {
            const o = (outletSummaryList || []).find(it => it.id === parseInt(outlet.id, 10));
            outlet.name = o.name;
        });

        const reloadList = function(){
            // $route.reload();
            $routeSegment.chain[0].reload();
        };

        vm.outlets = outlets;
        vm.isEmpty = machines.length === 0;
        vm.sorter = "name";
        vm.showWelcome = false;
        vm.loaded = true;

        // // www.jeffryhouser.com/index.cfm/2014/6/2/How-do-I-run-code-when-a-variable-changes-with-angularjs
        // $scope.$apply();

		vm.create = function() {
			const resolvers = {
				userAction() {
					return 'create';
				},
				editRecord() {
					return {};
				}
			};
			showModalforAddOrEdit(resolvers);
		};

		vm.edit = function(machineRefId) {

            const machine = outlets
                .reduce( (machineAcc, outlet) => machineAcc.concat(outlet.machines), [])    //outlet*.machines
                .find( m => m.machineRefId === machineRefId );

			const resolvers = {
				userAction() {
					return 'edit';
				},
				editRecord() {
					return machine;
				}
			};
			showModalforAddOrEdit(resolvers);
		};

		const showModalforAddOrEdit = (resolvers) => {

			const modalInstance = $uibModal.open({
				template: require('../controllers/merchant/modalMachine.html'),
				controller: 'MachinesModalDialogController as vm',
				windowClass: 'modal-huge',
				backdrop: 'static',
				resolve: resolvers
			});

			modalInstance.result.then((result) => {
				if (result === 'done') {
					reloadList();
				}
			}).catch(handleModalError);
		};


		vm.delete = function(machine) {
			const modalInstance = $uibModal.open({
                template: require('../templates/common/modalDialog.html'),
				controller: 'commonModalDialogController',
				windowClass: 'fade',
				backdrop: 'static',
				resolve: {
					title() {
						return gettextCatalog.getString('Delete Machine');
					},
					confirmButtonName() {
						return gettextCatalog.getString('Delete');
					},
					confirmMsg() {
						return gettextCatalog.getString('Are you sure you want to delete ') + machine.name + ' ?';
					},
					multiMsgArray() {
						return [];
					}
				}
			});

			modalInstance.result
                .then((result) => {
                    if (result === 'ok') {
                        return deleteMachineFn(machine);
                    }
                })
                .then(() => {reloadList();})
                .catch(handleModalError);
		};



		vm.showQrCode = function(machine) {
            const modalInstance = $uibModal.open({
				template: require('../controllers/merchant/machineQrCode.html'),
				controller($scope, $uibModalInstance, $timeout) {
					$scope.qrCodeData = machine.machineRefId || '';
					$scope.cancel = function() {
						$uibModalInstance.close();
					};

					$scope.onDownloadQrCode = function() {
						$timeout(() => {
							const eleQrCode = angular.element('#eleQrCode')[0].querySelector('a');
							eleQrCode.click();
						}, 100);
					};
				},
				windowClass: 'fade',
				size: 'sm',
				backdrop: 'static'
			});

            modalInstance.result.catch(handleModalError);
		};

		function handleModalError(reason){
            if (reason !== 'escape key press') {
                messageService.error(reason);
            }
		}
	}



// WEBPACK FOOTER //
// ./src/controllers/machines.controller.js